import PropTypes from 'prop-types';
import React from 'react';
import ReactDataGrid from 'react-data-grid';

const {
    Draggable: { Container: DraggableContainer, RowActionsCell, DropTargetRowContainer },
    Data: { Selectors },
} = require('react-data-grid-addons');

const RowRenderer = DropTargetRowContainer(ReactDataGrid.Row);

class DocumentSectionListEditor extends React.Component {
    static propTypes = {
        rowKey: PropTypes.string.isRequired,
        sections: PropTypes.array,
        onSectionChange: PropTypes.func,
    };

    // GET /document/:documentId does not return sections -- nothing persists them since the
    // postgres migration -- so this is undefined for every document, and createRows threw.
    static defaultProps = { rowKey: 'id', sections: [] };

    constructor(props) {
        super(props);
        this._columns = [
            { key: 'xpath', name: 'Section XPath', editable: true, resizable: true },
            { key: 'comment', name: 'Administrators Comment', editable: true, resizable: true },
        ];
        this.state = { rows: this.createRows(props.sections), selectedIds: [] };
    }

    createRows = (sections = []) => {
        let rows = sections.map((section, i) => {
            return { id: i, xpath: section.sectionXpath, comment: section.sectionNote };
        });
        rows.push({ id: sections.length, xpath: '', comment: '' });
        return rows;
    };

    rowGetter = i => {
        return this.state.rows[i];
    };

    isDraggedRowSelected = (selectedRows, rowDragSource) => {
        if (selectedRows && selectedRows.length > 0) {
            let key = this.props.rowKey;
            return selectedRows.filter(r => r[key] === rowDragSource.data[key]).length > 0;
        }
        return false;
    };

    reorderRows = e => {
        if (
            e.rowSource.idx === this.state.rows.length - 1 ||
            e.rowTarget.idx === this.state.rows.length - 1
        )
            return;
        let selectedRows = Selectors.getSelectedRowsByKey({
            rowKey: this.props.rowKey,
            selectedKeys: this.state.selectedIds,
            rows: this.state.rows,
        });
        let draggedRows = this.isDraggedRowSelected(selectedRows, e.rowSource)
            ? selectedRows
            : [e.rowSource.data];
        let undraggedRows = this.state.rows.filter(function (r) {
            return draggedRows.indexOf(r) === -1;
        });
        let args = [e.rowTarget.idx, 0].concat(draggedRows);
        Array.prototype.splice.apply(undraggedRows, args);
        this.setState(() => {
            this.props.onSectionChange(undraggedRows);
            return { rows: undraggedRows };
        });
    };

    onGridRowsUpdated = ({ fromRow, toRow, updated }) => {
        this.setState(state => {
            const rows = state.rows.slice();
            for (let i = fromRow; i <= toRow; i++) {
                rows[i] = { ...rows[i], ...updated };
            }
            if (
                fromRow === rows.length - 1 &&
                (rows[fromRow].xpath === '' || rows[fromRow].comment === '')
            ) {
                rows.push({ id: fromRow + 1, xpath: '', comment: '' });
            }
            this.props.onSectionChange(rows);
            return { rows };
        });
    };

    render() {
        return (
            <DraggableContainer>
                <ReactDataGrid
                    rowActionsCell={RowActionsCell}
                    columns={this._columns}
                    rowGetter={this.rowGetter}
                    rowsCount={this.state.rows.length}
                    minHeight={300}
                    rowRenderer={<RowRenderer onRowDrop={this.reorderRows} />}
                    onGridRowsUpdated={this.onGridRowsUpdated}
                    enableCellSelect={true}
                />
            </DraggableContainer>
        );
    }
}

export { DocumentSectionListEditor };
